import {Component, OnInit} from '@angular/core';

import {ModalService} from '../../services/modal/modal.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {

  public visible: boolean;

  constructor(
      private modalService: ModalService
  ) {}
 
  ngOnInit() {
    this.initModal();
  }

  initModal(){
    let recuperaCookie = this.modalService.getCookie(environment.COOKIES.TEXT_LEGAL.NOM);
    if(recuperaCookie === '' && environment.HABILITA_MODAL_TEXT_LEGAL === true)
    {
      this.modalService.openModal();
      this.visible = true;
    }
    else
      this.visible = false;
  }

  confirmCookies(){
    this.modalService.setCookie(
      environment.COOKIES.TEXT_LEGAL.NOM,
      false,
      environment.COOKIES.TEXT_LEGAL.DIES);
    this.closeModal();
  }

  closeModal() {
    this.modalService.closeModal();
    this.visible = false;
  }
}


// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/modal/modal.component.ts